import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * /content is a container — redirect to the default child so the URL is always
 * explicit about which module is open. Overview is the landing.
 */
export const Route = createFileRoute('/_authenticated/_tenant/content/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing a redirect
    throw redirect({ to: '/content/overview' });
  },
});
